import { t } from "@lingui/macro";
import {
  BellRingingIcon,
  EnvelopeSimpleIcon,
  FileTextIcon,
  GearSixIcon,
  HouseIcon,
  LayoutIcon,
  LifebuoyIcon,
  MegaphoneIcon,
  ReadCvLogoIcon,
  StarIcon,
  UserPlusIcon,
  UsersThreeIcon,
  WalletIcon,
} from "@phosphor-icons/react";

import type { NavigationSection } from "../types/navigation";

export const USER_SPACE_BASE_PATH = "/client/user-space";

export const USER_SPACE_PATHS = {
  dashboard: USER_SPACE_BASE_PATH,

  resumes: `${USER_SPACE_BASE_PATH}/resumes`,
  coverLetters: `${USER_SPACE_BASE_PATH}/cover-letters`,

  referral: `${USER_SPACE_BASE_PATH}/referrals`,
  ambassador: `${USER_SPACE_BASE_PATH}/ambassador`,
  fidelity: `${USER_SPACE_BASE_PATH}/loyalty`,
  wallet: `${USER_SPACE_BASE_PATH}/wallet`,

  resumeTemplates: `${USER_SPACE_BASE_PATH}/templates/resumes`,
  coverLetterTemplates: `${USER_SPACE_BASE_PATH}/templates/cover-letters`,

  settings: `${USER_SPACE_BASE_PATH}/settings`,
  notifications: `${USER_SPACE_BASE_PATH}/notifications`,
  aiCredits: `${USER_SPACE_BASE_PATH}/ai-credits`,
  offers: `${USER_SPACE_BASE_PATH}/offers`,
  help: `${USER_SPACE_BASE_PATH}/help`,
} as const;

export const USER_SPACE_NAVIGATION: NavigationSection[] = [
  {
    items: [
      {
        label: "Tableau de bord",
        path: USER_SPACE_PATHS.dashboard,
        icon: HouseIcon,
        description: "Vue générale de mes documents",
      },
    ],
  },

  {
    label: "Mes documents",
    icon: FileTextIcon,
    collapsible: true,
    defaultExpanded: true,
    items: [
      {
        label: "Mes CVs",
        path: USER_SPACE_PATHS.resumes,
        icon: ReadCvLogoIcon,
        description: "Créer et gérer mes CV",
      },
      {
        label: "Mes lettres de motivation",
        path: USER_SPACE_PATHS.coverLetters,
        icon: EnvelopeSimpleIcon,
        description: "Créer et gérer mes lettres",
      },
    ],
  },

  {
    label: "Affiliation & Fidélité",
    icon: UsersThreeIcon,
    collapsible: true,
    defaultExpanded: false,
    items: [
      {
        label: "Parrain",
        path: USER_SPACE_PATHS.referral,
        icon: UserPlusIcon,
        description: "Inviter mes proches et suivre mes filleuls",
      },
      {
        label: "Ambassadeur",
        path: USER_SPACE_PATHS.ambassador,
        icon: MegaphoneIcon,
        description: "Partager et suivre mon code promotionnel",
      },
      {
        label: "Programme de fidélité",
        path: USER_SPACE_PATHS.fidelity,
        icon: StarIcon,
        description: "Consulter mes points et mes actions",
      },
      {
        get label() {
          return t`Portefeuille et retraits`;
        },
        path: USER_SPACE_PATHS.wallet,
        icon: WalletIcon,
        description: "Gérer mon solde et retirer mes gains",
      },
    ],
  },

  {
    label: "Modèles",
    icon: LayoutIcon,
    collapsible: true,
    defaultExpanded: false,
    items: [
      {
        label: "Modèles de CV",
        path: USER_SPACE_PATHS.resumeTemplates,
        icon: ReadCvLogoIcon,
        description: "Découvrir les modèles de CV",
      },
      {
        label: "Modèles de lettres",
        path: USER_SPACE_PATHS.coverLetterTemplates,
        icon: EnvelopeSimpleIcon,
        description: "Découvrir les modèles de lettres",
      },
    ],
  },

  {
    items: [
      {
        label: "Notifications",
        path: USER_SPACE_PATHS.notifications,
        icon: BellRingingIcon,
        description: "Suivre l'activité de mon compte",
      },
      {
        label: "Paramètres",
        path: USER_SPACE_PATHS.settings,
        icon: GearSixIcon,
        description: "Gérer mon profil et mon compte",
      },
    ],
  },
];
